export function squareFeetToSquareInches(squareFeet: number): number {
  return squareFeet * 144;
}

export function squareInchesToSquareFeet(squareInches: number): number {
  return squareInches / 144;
}
